var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-cont-phone"},[_c('h2',[_vm._v(_vm._s(_vm.tit))]),_c('h4',[_vm._v(_vm._s(_vm.subheading))]),_c('div',{staticClass:"dec"},[_c('span',[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }